import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import ProductAvailabilityModel from "../../models/products/productavailability-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.PRODUCT) +"/api/ProductAvailability/GetProductAvailability";// //{/api/Category/GetAllCategory}`)  //// "https://localhost:7054/api/Category/GetAllCategory";
export const useGetProductAvailabilities = createQuery<
  ProductAvailabilityModel[],
  null,
  AxiosError
>({
  queryKey: ["keyProductAvailabilitylist"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    
  // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
